import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import "./App.css";
import Test from "./Test";
import axios from "axios";
import ChangePassword from "./components/MainPage/Administration/Settings/ChangePassword";
import Department from "./components/MainPage/Administration/Settings/Department";
import Designation from "./components/MainPage/Administration/Settings/Designation";

import UserAdd from "./components/MainPage/Administration/Settings/UserAdd";

import EmployeeInformationForm from "./components/MainPage/Employees/EmployeeInformationForm/EmployeeInformationForm";
import AllEmployeeReports from "./components/MainPage/Employees/Employees/AllEmployeeReports";
import AllEmployees from "./components/MainPage/Employees/Employees/Allemployees";

// import Profile from "./components/MainPage/Employees/Employees/Profile";

import Singleprofile from "./components/MainPage/Employees/Employees/SingleProfile";

import EmployeeProfile from "./components/MainPage/Employees/Employees/employeeprofile";
import Employeeslist from "./components/MainPage/Employees/Employees/employeeslist";
import Admindashboard from "./components/MainPage/Main/Dashboard/Admindashboard";
import EmployeeDashboard from "./components/MainPage/Main/Dashboard/employeedashboard";
import Header from "./components/initialpage/Sidebar/header.jsx";
import Sidebar from "./components/initialpage/Sidebar/sidebar";

//------------------------------- transport section start----------------------------------------

// -------------------------------------- end --------------------------------------------

import Cookies from "js-cookie";

import swal from "sweetalert";

import AddSignature from "./components/MainPage/Administration/Settings/AddSingnature";
import AddSubModule from "./components/MainPage/Administration/Settings/AddSubModule";
import Role from "./components/MainPage/Administration/Settings/Role";

import NotFound from "./components/initialpage/NotFound.js";
import useAuth from "./components/initialpage/hooks/useAuth";
// documets inport file

import baseApi from "./components/initialpage/hooks/baseApi";

// end
function HrApp(props) {
  const { logAudit, user, hasError } = useAuth();
  const [userLoginData, setUserLoginData] = useState(user);

  useEffect(() => {
    setIsLoading(true);
    axios
      .get(`https://${baseApi}/auth/getLoginUser`)
      .then((data) => {
        setUserLoginData(data.data.user);
      })
      .catch((error) => { });
  }, []);
  let logId = userLoginData?.user_id;
  // let logId = userLoginData ? userLoginData.user_id : "";
  const [isLoading, setIsLoading] = useState(false);
  let pathName = window.location.pathname;
  console.log(userLoginData);
  //  login status handeling
  const oldStatus = sessionStorage.getItem("statusId");
  const logInStatus = Cookies.get("Role");

  if (!logInStatus && oldStatus) {
    swal({
      title: "Your session has expired, please login",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        window.location.reload();
      } else {
        window.location.reload();
      }
    });
    sessionStorage.removeItem("statusId");
  }
  const navigate = useNavigate();

  if (pathName !== "/allemployees/employeeprofile/") {
    sessionStorage.removeItem("search_name");
  }
  if (pathName.includes("hr/docs")) {
    sessionStorage.setItem("adSubModule", 6);
  }
  if (
    !pathName.includes("hr/docs") &&
    !pathName.includes("hr/lease") &&
    pathName.includes("hr/")
  ) {
    sessionStorage.setItem("moduleId", 1);
    sessionStorage.setItem("adSubModule", 1);
  }

  console.log = console.warn = console.error = console.dirxml = console.trace = console.info = console.dir = () => { };

  return (
    <div className="App">
      {!hasError && (
        <>
          {logInStatus && (
            <>
              <Sidebar /> <Header />
            </>
          )}

          {logId && logInStatus && (
            <>
              <Routes>
                <Route exact path="/" element={<EmployeeDashboard />} />

                {
                  <>
                    <>
                      <Route
                        exact
                        path="/admindashboard"
                        element={<Admindashboard />}
                      />

                      <Route
                        path="/employeedashboard"
                        element={<EmployeeDashboard />}
                      />

                      <>
                        <Route
                          path="/allemployees"
                          element={<AllEmployees />}
                        />

                        <Route
                          path="/employeeslist"
                          element={<Employeeslist />}
                        />
                        {/* <Route
                          path="/allemployees/employeeprofile/:emp_id/profile/:emp_id"
                          element={<Profile />}
                        />
                        <Route
                          path="/employeeslist/employeeprofile/:emp_id/profile/:emp_id"
                          element={<Profile />}
                        /> */}
                        <Route
                          path="/employeeinformationform"
                          element={<EmployeeInformationForm />}
                        />
                        <Route
                          path="/allemployeesreports"
                          element={<AllEmployeeReports />}
                        />
                      </>

                      <>
                        <Route path="/usersadd" element={<UserAdd />} />

                        <Route path="/designation" element={<Designation />} />
                        <Route path="/department" element={<Department />} />
                        <Route path="/signature" element={<AddSignature />} />
                        <Route path="/allrole" element={<Role />} />
                      </>

                      <Route path="/test" element={<Test />} />
                    </>

                    <Route path="/addsubmodule" element={<AddSubModule />} />
                  </>
                }

                <Route
                  path="/employeeprofile/:EmpID"
                  element={<EmployeeProfile />}
                />
                {/* <Route
                  path="/singleprofile/profile/:emp_id"
                  element={<Profile />}
                /> */}
                <Route path="/singleprofile" element={<Singleprofile />} />
                <Route path="/changepassword" element={<ChangePassword />} />

                {/* end documents */}

                <Route path="*" exact={true} element={<NotFound />} />
              </Routes>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default HrApp;
